import React from 'react';
import './statusOverlay.css';

const StatusOverlay = ({loadingStatus}) => {

  return (
    <span className={`StatusOverlayPage ${loadingStatus ? 'StatusOverlayPageActive' : 'StatusOverlayPageInactive'}`}>
      <span className="LoadingLogo">
        <span className="BlueW">W</span>
        <span className="GreenW">W</span>
      </span>
      <h1 className="Status">{loadingStatus}</h1>
    </span>
  );

};

export default StatusOverlay;


// WEBPACK FOOTER //
// ./src/components/universal/statusOverlay/statusOverlay.js